import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createContentRow } from '../../../redux/actions/pagesActions';
import TextFieldGroup from '../../common/TextFieldGroup';
import { Box, Button } from '@material-ui/core';
import { Theme } from '../../../utils/Theme';
import { withStyles } from '@material-ui/styles';
import Header from '../../layout/Partials/Header';
import { withRouter } from 'react-router-dom';
import AdminLayout from '../../layout/AdminLayout';
import clsx from 'clsx';
import PreviewCols from './Partials/previewCols';
import Section from '../../UI/Section';
import ThemedSlider from '../../common/ThemedSlider';

const styles = Theme();

class CreateRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: 1,
            height: '100',
            sort: '1',
        };
    }

    onSubmit = (e) => {
        e.preventDefault();
        const page = this.props.match.params.id;
        const { columns, height, sort } = this.state;
        const data = { page, columns, height, sort };

        //THIS IS BAD TODO : MODE THIS FUNCTION TO AN API FILE or REDUX ACTION
        this.props.createContentRow(data, this.props.history);
    };
    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };
    onResourceSelect = (e) => {
        e.preventDefault();
        this.setState({ columns: e.target.value });
    };

    render() {
        const { columns, height, sort } = this.state;
        const { classes } = this.props;

        return (
            <AdminLayout>
                <div className="o-page">
                    <Header hideSearchBartitle={'New Row'} />
                    <Box component="span" className="u-m-xsmall ">
                        <div className={clsx('full_height u-p-small')}>
                            <Section>
                                <div className={'u-m-small'}>
                                    <div className="o-line ">
                                        <div>
                                            <h4 className={`c-card__title `}>
                                                Create Content Row
                                            </h4>
                                        </div>
                                        <div>
                                            <Button
                                                className={`${classes.buttonSecondary}`}
                                                onClick={(e) =>
                                                    this.props.history.goBack()
                                                }
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>

                                    <div
                                        className={
                                            'c-divider u-mt-small u-mb-small'
                                        }
                                    />
                                    <form onSubmit={this.onSubmit}>
                                        <div className={'row'}>
                                            <div className={'col-sm-4'}>
                                                <TextFieldGroup
                                                    label={
                                                        'Objects Height (px)'
                                                    }
                                                    value={height}
                                                    onChange={this.onChange}
                                                    name={'height'}
                                                />
                                            </div>
                                            <div className={'col-sm-4'}>
                                                <TextFieldGroup
                                                    label={'Sort Order'}
                                                    value={sort}
                                                    onChange={this.onChange}
                                                    name={'sort'}
                                                />
                                            </div>
                                            <div
                                                className={'col-sm-4'}
                                                style={{ paddingTop: '23px' }}
                                            >
                                                <Button
                                                    type={'submit'}
                                                    className={`c-btn u-p-xsmall c-btn--fullwidth ${classes.buttonPrimary}`}
                                                >
                                                    Create Row
                                                </Button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <Section elevation={0} style={{ padding: 10 }}>
                                    <Box
                                        component="span"
                                        className={clsx('u-mv-small u-p-small')}
                                    >
                                        <div className="o-line c-card__title">
                                            <h5 className={`c-card__title `}>
                                                Row height preview
                                            </h5>
                                        </div>
                                        <Box component="span">
                                            <ThemedSlider
                                                defaultValue={columns}
                                                marks
                                                min={1}
                                                max={12}
                                                color={'primary'}
                                                step={1}
                                                onChange={(event, value) => {
                                                    this.setState({
                                                        columns: value,
                                                    });
                                                }}
                                                valueLabelDisplay="auto"
                                                aria-labelledby="discrete-slider-small-steps"
                                                getAriaValueText={(value) =>
                                                    `${value} columns`
                                                }
                                            />
                                        </Box>

                                        <div
                                            className={'c-card__body u-p-zero'}
                                        >
                                            <PreviewCols
                                                height={height || 0}
                                                columns={columns || 0}
                                                classes={classes}
                                            />
                                        </div>
                                    </Box>
                                </Section>
                            </Section>
                        </div>
                    </Box>
                </div>
            </AdminLayout>
        );
    }
}

CreateRow.propTypes = {
    createContentRow: PropTypes.func.isRequired,
    pages: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    classes: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
};

const mapStateToProps = (state) => ({
    pages: state.pages,
    errors: state.errors,
});

export default connect(mapStateToProps, { createContentRow })(
    withRouter(withStyles(styles)(CreateRow))
);
